import React, {useEffect} from "react"

// Internals
import './_style.scss';

const AccordionGroup = ({ index, children, ...props }) => {
  const compClassName = "accordion-group"
  const compClass =
    props?.className !== undefined
      ? compClassName + " " + props?.className
      : compClassName


  const scrollIntoViewWithOffset = (element, offset) => {
    window.scrollTo({
      behavior: 'smooth',
      top:
        element.getBoundingClientRect().top -
        document.body.getBoundingClientRect().top -
        offset,
    })
  }


  useEffect(() => {

    const accordionElement = document.getElementById(index)
    document.querySelectorAll('button.accordion-button').forEach(function(elem){
      elem.onclick = function(){
        accordionElement.addEventListener('hidden.bs.collapse', (event) => {
          scrollIntoViewWithOffset(elem, document.querySelector('#main-header').offsetHeight)
        })
        accordionElement.addEventListener('shown.bs.collapse', (event) => {
          scrollIntoViewWithOffset(elem, document.querySelector('#main-header').offsetHeight)
        })
      }
    })
  }, [])

  return (
    <div comp="accordion-group" className={compClass} id={index}>
      {children}
    </div>
  )
}

export default AccordionGroup
